module.exports = __webpack_public_path__ + "img/chenyumeng.dfacc249.jpg";